// extracted by mini-css-extract-plugin
module.exports = {"bullet":"CoffeeBullet_bullet__o8enO","full":"CoffeeBullet_full__L_tp_"};